import BaseSubscriberService from './baseSubscriberService';

export default class LoadingService extends BaseSubscriberService {
  constructor() {
    super();
  }

  startLoading() {
    this.broadcast(true);
  }

  endLoading() {
    this.broadcast(false);
  }
}
